export const tr = {
    'clear-all-areas': 'Tüm alanları temizle',
    'clear-area': 'Alanı temizle',
    'draw-area': 'Alan çiz',
    'show-selected': 'Seçimleri göster'
};
